<style scoped lang="sass">
@import '../../variables'

a
  font-weight: 600
.secondary
  margin: 0.2rem 0 0.5rem
  font-size: 0.8em
  color: #666
  .customer-name
    // 
  .small-details
    font-size: 0.9em
    margin-top: 0.7em
    line-height: 1.6em
</style>

<template lang="pug">
el-card()
  router-link(:to="'/user/requests/' + request.id") {{ request.name }}
  .secondary
    //- .customer-name {{ request.customer_account_name }}
    status-tag(:status='request.status')
    .small-details
      i.mat-icon person
      |  {{ request.people }}
      span.hpad {{ $formatCents(request.budget_cents) }}/person
      br
      span
        i.mat-icon date_range
        |  {{ $formatDate(request.delivery_date) }}
      br
      | Request \#{{ request.id }}
</template>

<script>
import moment from 'moment'
import StatusTag from '../../common/StatusTag.vue'

export default {
  props: {
    request: {
      required: true,
      type: Object,
    },
  },
  data ( ) {
    return {
      moment,
    }
  },
  components: {
    StatusTag,
  },
}
</script>


// WEBPACK FOOTER //
// src/user/blocks/RequestMini.vue